import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageNotFoundService {
  isPageNotFound = signal(false);
}
